<template>
  <div>
    <button
      class="ml-2 btn btn-light-grey mt-2 mb-2"
      v-shortkey.once="this.modalOpen ? null : ['enter']"
      @click="search"
      @shortkey="disabled ? '' : search()"
      :disabled="disabled"
      :title="disabled ? $t('global.pleasechangethetab') : ''"
    >
      {{ $t("global.search") }}
    </button>
    <button
      class="ml-2 btn btn-light-grey mt-2 mb-2"
      @click="reset"
      :disabled="disabled"
      :title="disabled ? $t('global.pleasechangethetab') : ''"
    >
      {{ $t("global.reset") }}
    </button>
  </div>
</template>

<script>
export default {
  name: "FilterSuchenButton",
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      modalOpen: false,
    };
  },
  mounted() {
    this.$bus.$on("sucheModalOpen", () => {
      this.modalOpen = true;
    });
    this.$bus.$on("sucheModalClose", () => {
      this.modalOpen = false;
    });
  },
  methods: {
    search() {
      this.$bus.$emit("searchWithFilter");
    },
    reset() {
      this.$bus.$emit("resetFilter");
    },
  },
};
</script>